import { ILoggingSettings, LoggingLevel } from "./types";

/**
 * Substituční znak pro logovanou zprávu. Nahrazuje se za odpovídající argument převedený na string (přes _arg.toString()_).
 *
 * Více viz {@link ILogger.log}.
 */
export const STRING_SUBSTITUTION = "%s";

/**
 * Substituční znaky pro logovanou zprávu. Očekává, že odpovídající argument je (celé) číslo. Nahrazuje za toto číslo (oříznuté o desetinou část).
 *
 * Více viz {@link ILogger.log}.
 */
export const INTEGER_SUBSTITUTIONS = ["%i", "%d"];

/**
 * Substituční znak pro logovanou zprávu. Očekává, že odpovídající argument je (desetinné) číslo. Nahrazuje za toto číslo.
 *
 * Více viz {@link ILogger.log}.
 */
export const FLOAT_SUBSTITUTION = "%f";

/**
 * Dvojité procento se nahrazuje za jednoduché procento.
 */
export const DOUBLE_PERCENTAGE_SUBSTITUTION = "%%";

/**
 * Pro potřeby utility `substituteArguments`. Regex pro rozdělení `message` podle substitučních znaků.
 * - Např. "ahoj %s nazdar" -> ["ahoj", "%s", "nazdar"]
 * - Nebo. "ahoj %%%s nazdar" -> ["ahoj", "%%", "", "%s", "nazdar"]
 */
export const MESSAGE_SPLIT_REGEX = /(%[sidf%])/;

/**
 * Maximální očekávaná hloubka objektů, které budeme kopírovat přes {@link deepCopy}.
 */
export const MAX_DEEP_COPY_LEVEL = 1000;

/**
 * Konstanta pro prázdný objekt. Umožňuje porovnávání referencí.
 */
export const EMPTY_OBJECT = {};

/**
 * Konstanta pro prázdné pole. Umožňuje porovnávání referencí.
 */
export const EMPTY_ARRAY: ReadonlyArray<any> = [];

/**
 * Výchozí nastavení logování pro vývoj.
 */
export const DEFAULT_DEV_LOGGING_SETTINGS: ILoggingSettings = {
    sections: {
        // schválně prázdné, uplatní se default
    },
    defaultLevel: LoggingLevel.info,
};

/**
 * Výchozí nastavení logování pro produkci.
 */
export const DEFAULT_PRODUCTION_LOGGING_SETTINGS: ILoggingSettings = {
    sections: {
        // schválně prázdné, uplatní se default
    },
    defaultLevel: LoggingLevel.error,
};
